var OperationsClass = (function () {
    function OperationsClass() {
    }
    OperationsClass.prototype.getOperation = function (name) {
        for (var i; i < this.Operation.length; i++) {
            var operation = this.Operation[i];
            if (operation.Name == name)
                return operation;
        }
        return null;
    };
    return OperationsClass;
}());
//# sourceMappingURL=OperationsClass.js.map